import { AfterViewChecked, Component, Inject, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';


import { environment } from '../../../environments/environment';
import { CentreService } from '../../services/centre.service';
import { Centre } from '../../models/centre.model';

import { PLATFORM_ID } from '@angular/core';
import { DatePipe, isPlatformBrowser } from '@angular/common';
import { Title, Meta } from '@angular/platform-browser';
import { HP } from '../../models/hp.model';
import { Pave } from '../../models/pave.model';
import { SuivisService } from '../../services/suivis.service';
import { renderFlagCheckIfStmt } from '@angular/compiler/src/render3/view/template';
import { FormBuilder } from '@angular/forms';
import { UtilisateurService } from 'src/app/services/utilisateur.service';

@Component({
  selector: 'home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss']
})
export class HomeComponent implements OnInit, AfterViewChecked {
  environment = environment;
  suivisMap: Map<any,[any]>;
  suivisMapValues;
  userForm = this.fb.group({
    user: [],
        
  });
  utilisateurs;
  isAdmin = false;

  constructor( 
    private suivisService: SuivisService,
    private datePipe: DatePipe,
    private fb: FormBuilder,
    protected utilisateurService: UtilisateurService,

    ) {
  }

  ngOnInit() {
    

    if( localStorage.getItem('accesVueTousUsers') == '1' )this.isAdmin= true;

    this.utilisateurService.query().subscribe(res=>{
      this.utilisateurs =res.body;
      this.suivisService.querySuivisForMe().subscribe(res=>{
        this.loadSuivis(res.body);
     });
    });
    
  }


  loadSuivis(suivis){
    this.suivisMap = new Map();
    for(let suivi of suivis){
      let date = Date.parse(suivi.datePrevue);
      let now = new Date(Date.now());
      now.setHours(0);
      now.setMinutes(0);
      now.setSeconds(0);
      let diffDays:any  =  (now.getTime()- date) / (1000 * 3600 * 24);
      diffDays =Math.round(diffDays);
      if(diffDays<-15) {
        suivi.early = true;
      }
      if(parseInt(diffDays) === 0) suivi.datePrevueDisplay = "Aujourd'hui";
      if(parseInt(diffDays) === 1) suivi.datePrevueDisplay = "Hier";
      if(parseInt(diffDays) === 2) suivi.datePrevueDisplay = "Avant hier";
      if(parseInt(diffDays) === -1) suivi.datePrevueDisplay = "Demain";
      if(parseInt(diffDays) === -2) suivi.datePrevueDisplay = "Après demain";
      if( parseInt(diffDays) < -2 ) suivi.datePrevueDisplay = "Dans " + diffDays*-1 + " jours";
      if( parseInt(diffDays) > 2 ) suivi.datePrevueDisplay = "En retard de " + diffDays + " jours";

      date = Date.parse(suivi.dateFaite); 
      diffDays =  (now.getTime()- date) / (1000 * 3600 * 24);
      diffDays =Math.round(diffDays);
      if(parseInt(diffDays) === 0) suivi.dateFaite = "Aujourd'hui"; 
      if(parseInt(diffDays) === 1) suivi.dateFaite = "Hier";
      if(parseInt(diffDays) > 1 || parseInt(diffDays) < 0 ) suivi.dateFaite = "Il y a "+parseInt(diffDays)+" jours";
      // if(parseInt(diffDays) > 1 || parseInt(diffDays) < 0 ) suivi.dateFaite = this.datePipe.transform(Date.parse(suivi.dateFaite),'dd/MM/yy');

      if(this.suivisMap.has(suivi.idSuivi)){
        this.suivisMap.get(suivi.idSuivi).push(suivi)
      }else{
        this.suivisMap.set(suivi.idSuivi, [suivi])
      }
    }

    for(const a of this.suivisMap.values()){ 
      a.sort((a,b)=>{
        return a.id-b.id
      })
      if(a[a.length-1].early){
        this.suivisMap.delete(a[a.length-1].idSuivi);
      }

    }
    this.suivisMapValues = Array.from(this.suivisMap.values());
    this.suivisMapValues.sort((a,b)=>{
      if(a[a.length-1].datePrevue<b[b.length-1].datePrevue) return -1;
      else return 1;
    })
  }

  ngAfterViewChecked() {
    
  }

  
  color(date){
    if(date == "Aujourd'hui") return 'green';
    else if(date == "Hier") return 'yellow';
    else if(date == "Avant hier") return 'orange';
    else if(date.substring(0,2) == "En") return 'red';
    else if(date.substring(0,2) == "Da") return 'lightgrey';
    else if(date == "Demain" || date == "Après demain") return 'lightseagreen';
    
  }

  changeUser(){
    this.suivisService.querySuivis(this.userForm.get(['user']).value).subscribe(res=>{
      this.loadSuivis(res.body);
   });
  }
  

}
